module.exports = __webpack_public_path__ + "img/icon-entrance.e9394a23.svg";